import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const AuthReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Autenticar el usuario y obtener la data del pss
   */
  builder
    .addCase(Types.AUTH_USER_LOADING, (state) => {
      state.authUserLoading = true;
      state.authUserError = null;
    })
    .addCase(Types.AUTH_USER_SUCCESS, (state, action) => {
      const { authUserData } = action;
      state.authUserData = authUserData;
      state.authUserLoading = false;
      state.authUserError = null;
    })
    .addCase(Types.AUTH_USER_FAILURE, (state, action) => {
      const { authUserError } = action;
      state.authUserData = INITIAL_STATE.authUserData;
      state.authUserLoading = false;
      state.authUserError = authUserError;
    });

  /**
   * Obtener un número de sesión
   */
  builder
    .addCase(Types.NUEVA_SESION_LOADING, (state) => {
      state.nuevaSesionLoading = true;
      state.nuevaSesionError = null;
    })
    .addCase(Types.NUEVA_SESION_SUCCESS, (state, action) => {
      const { nuevaSesionData } = action;
      state.nuevaSesionData = nuevaSesionData;
      state.nuevaSesionLoading = false;
      state.nuevaSesionError = null;
    })
    .addCase(Types.NUEVA_SESION_FAILURE, (state, action) => {
      const { nuevaSesionError } = action;
      state.nuevaSesionData = INITIAL_STATE.nuevaSesionData;
      state.nuevaSesionLoading = false;
      state.nuevaSesionError = nuevaSesionError;
    });

  /**
   * Logout y limpiar datos
   */
  builder
  .addCase(Types.LOGOUT_USER_LOADING, (state) => {
    state.logoutUserLoading = true;
    state.logoutUserError = null;
  })
  .addCase(Types.LOGOUT_USER_SUCCESS, (state, action) => {
    const { logoutUserData } = action;
    state.logoutUserData = logoutUserData;
    state.authUserData = INITIAL_STATE.authUserData;
    state.nuevaSesionData = INITIAL_STATE.nuevaSesionData;
    state.logoutUserLoading = false;
    state.logoutUserError = null;
  })
  .addCase(Types.LOGOUT_USER_FAILURE, (state, action) => {
    const { logoutUserError } = action;
    state.logoutUserError = INITIAL_STATE.logoutUserError;
    state.logoutUserLoading = false;
    state.logoutUserError = logoutUserError;
  });

  /**
   * Limpiar datos sesion
   */
  builder.addCase(Types.CLEAR_SESION_SUCCESS, (state) => {
    state.nuevaSesionData = INITIAL_STATE.nuevaSesionData;
    state.nuevaSesionLoading = false;
    state.nuevaSesionError = INITIAL_STATE.nuevaSesionError;
  });

  /**
   * Limpiar datos login
   */
  builder.addCase(Types.CLEAR_LOGIN_SUCCESS, (state) => {
    state.authUserData = INITIAL_STATE.authUserData;
    state.authUserLoading = false;
    state.authUserError = INITIAL_STATE.authUserError;
  });

  /**
   * Actualizar correo del prestador
   */
  builder.addCase(Types.UPDATE_PRESTADOR_CORREO, (state, action) => {
    const { correoElectronico } = action;
    if (state.authUserData?.prestador) {
      state.authUserData.prestador.correoElectronico = correoElectronico;
    }
  });
});
